import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import ReportDateSelector, { DateRangeOption } from './ReportDateSelector';

const CohortHeatmap: React.FC = () => {
  const [range, setRange] = useState<DateRangeOption>('qtd');
  const [cohorts, setCohorts] = useState<any[]>([]);

  useEffect(() => {
    let isMounted = true;
    const fetchCohorts = async () => {
      try {
        const res = await api.analytics.getCohorts(range);
        if (isMounted && Array.isArray(res)) {
          setCohorts(res);
        }
      } catch (err) {
        console.error('Failed to load cohorts:', err);
      }
    };
    fetchCohorts();
    return () => { isMounted = false; };
  }, [range]);

  return (
    <div id="cohort-heatmap" className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h2 className="text-xl font-black text-slate-900 mb-1">Customer Retention Cohorts</h2>
          <p className="text-sm text-slate-500">Live retention performance across signup cohorts.</p>
        </div>
        <ReportDateSelector value={range} onChange={setRange} />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-left text-xs">
          <thead>
            <tr className="border-b border-slate-100">
              <th className="py-3 font-black text-slate-400 uppercase tracking-widest pr-4">Cohort</th>
              <th className="py-3 font-black text-slate-400 uppercase tracking-widest pr-4">Accounts</th>
              <th className="py-3 font-black text-slate-400 uppercase tracking-widest text-center">M0</th>
              <th className="py-3 font-black text-slate-400 uppercase tracking-widest text-center">M1</th>
              <th className="py-3 font-black text-slate-400 uppercase tracking-widest text-center">M2</th>
              <th className="py-3 font-black text-slate-400 uppercase tracking-widest text-center">M3</th>
              <th className="py-3 font-black text-slate-400 uppercase tracking-widest text-center">M4</th>
              <th className="py-3 font-black text-slate-400 uppercase tracking-widest text-center">M5</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {cohorts.map((row) => (
              <tr key={row.cohort}>
                <td className="py-3 font-bold text-slate-900">{row.cohort}</td>
                <td className="py-3 text-slate-500 font-semibold">{row.size}</td>
                {['m0', 'm1', 'm2', 'm3', 'm4', 'm5'].map((key) => {
                  const value = row[key];
                  if (value === null || value === undefined) return <td key={key} className="py-3"></td>;
                  
                  let bgColor = 'bg-emerald-50 text-emerald-700';
                  if (value >= 95) bgColor = 'bg-emerald-600 text-white';
                  else if (value >= 90) bgColor = 'bg-emerald-500 text-white';
                  else if (value >= 80) bgColor = 'bg-emerald-400 text-white';
                  else if (value >= 70) bgColor = 'bg-emerald-200 text-emerald-800';

                  return (
                    <td key={key} className="py-1 px-1">
                      <div className={`w-9 h-8 flex items-center justify-center rounded-lg font-bold mx-auto text-xs ${bgColor}`}>
                        {value}%
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CohortHeatmap;
